export default __webpack_public_path__ + "static/media/chairTtsIt_It60.b49ba7ec.mp3";